import {SET_WATCH_KEY} from "../actions/watchKey";

export default (state = null, action) => {
	switch (action.type) {
		case SET_WATCH_KEY:
			return action.watchKey;

		default:
			return state;
	}
};
